<template>
  <div
    class="-social"
    :class="{
      '-is-twitter': isTWITTER,
    }"
    @click="previewAsset"
  >
    <div class="-inner">
      <div v-if="showActions && !overlay" class="-actions">
        <wt-asset-locate @locate="$emit('locate')" :asset="asset" />
        <wt-asset-remove @remove="$emit('remove')" />
        <wt-asset-add :disabled="!canAdd" @add="$emit('add')" />
      </div>
      <img v-if="!isText" :src="thumbnailUrl" :draggable="false" />
      <div v-else class="-post">
        <div class="-post-text" dir="auto" v-text="asset.metadata.caption" />
      </div>
    </div>

    <div v-if="!overlay" class="-indicators">
      <transition name="wt2-fade-fast">
        <wt-asset-used v-if="isUsed" />
      </transition>
    </div>

    <wt-asset-icons-overlay-asset
      v-if="overlay"
      :duration="displayDuration"
      :icons="iconsForOverlayAsset"
    />
    <wt-asset-icons
      v-else
      :gradient="!isText"
      :icons="icons"
      :restrictions="assetRestrictions"
      :asset="asset"
      :author="displayName"
    />
  </div>
</template>

<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import AssetIconsForOverlayAsset from 'components/assets/mixins/AssetIconsForOverlayAsset.vue';
import AssetIcons from 'components/assets/mixins/AssetIcons.vue';

export default {
  mixins: [AssetMixins],
  components: {
    'wt-asset-icons-overlay-asset': AssetIconsForOverlayAsset,
    'wt-asset-icons': AssetIcons,
  },

  computed: {
    isText() {
      return !this.asset.metadata.providerLowResAssetUrl;
    },

    src() {
      return (
        this.asset.metadata.url ||
        this.asset.metadata.urlCdn ||
        this.asset.metadata.providerLowResAssetUrl
      );
    },

    thumbnailUrl() {
      if (this.isINSTAGRAM) {
        return this.mixinProxySrc(this.src);
      }
      return this.mixinSrc(this.src);
    },

    displayName() {
      if (!this.isText) {
        return false;
      }
      return this.asset.metadata.socialUserName.length
        ? this.asset.metadata.socialUserName
        : '@' + this.asset.metadata.socialUserScreenName;
    },
  },
};
</script>
